'use client'

import { useActionState, useState } from 'react'
import ErrorMessage from '../checkout/ErrorMessage'
import { signup } from '@onclicks/sharedmedusa/medusaData/customer'
import { Button } from '../ui/Button'
import { bagelFatOne } from '@/utilities/fontImport'
import { cn } from '@/utilities/ui'
import { Input } from '../ui/input'

const Register = () => {
  const [message, formAction, isPending] = useActionState(signup, null)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-[2.5rem] border border-white bg-white shadow-xl shadow-light-pink/40">
      <div className="h-1.5 bg-linear-to-r from-pink to-primary" />

      <div className="flex flex-col p-8 lg:p-10" data-testid="register-page">
        <span className="text-xs font-extrabold tracking-wide text-pink uppercase">
          Pas encore de compte ?
        </span>
        <h1 className={cn('text-2xl font-bold mt-2 mb-6 text-primary', bagelFatOne.className)}>
          Créer un compte
        </h1>

        <form className="w-full" action={formAction}>
          <div className="flex flex-col w-full gap-4">
            <div className="grid grid-cols-2 gap-3">
              <Input
                label="Prénom"
                id="first_name"
                type="text"
                name="first_name"
                placeholder="Prénom"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <Input
                label="Nom"
                id="last_name"
                type="text"
                name="last_name"
                placeholder="Nom"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>

            <Input
              label="Adresse e-mail"
              id="email"
              type="email"
              name="email"
              placeholder="Votre email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Input
              label="Mot de passe"
              id="password"
              type="password"
              name="password"
              placeholder="Votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Input
              label="Confirmation du mot de passe"
              id="confirm_password"
              type="password"
              name="confirm_password"
              placeholder="Confirmez votre mot de passe"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <ErrorMessage error={message} />

          <p className="mt-4 text-xs font-semibold text-primary/60">
            En créant un compte, vous acceptez nos conditions générales de vente.
          </p>

          <Button
            type="submit"
            disabled={isPending}
            className="mt-6 w-full"
            variant="gradientOrangeToPink"
          >
            Créer mon compte
          </Button>
        </form>
      </div>
    </div>
  )
}

export default Register
